<template>
  <!-- 元素周期表 -->
  <div class="elements">
    <!-- 第一行和第二行 -->
    <div class="first_tabel">
      <!-- 氢、锂、铍 -->
      <div class="first_tabel_item">
        <div class="top">
          <element-item class="one" :element="elemetList[0]" @updateList="updateList"></element-item>
          <element-item :isNum="true" :num="2"></element-item>
        </div>
        <div class="bottom">
          <element-item class="two" :element="elemetList[2]" @updateList="updateList"></element-item>
          <element-item :element="elemetList[3]" @updateList="updateList"></element-item>
        </div>
      </div>
      <!-- 焦点元素 -->
      <div class="first_tabel_force"></div>
      <div class="first_tabel_item">
        <div class="top">
          <element-item :isNum="true" :num="1 + item" v-for="item in 10" :key="'a' + item"></element-item>
        </div>
      </div>
      <!-- 硼、碳 -->
      <div class="first_tabel_item">
        <div class="top">
          <element-item :isNum="true" :num="13"></element-item>
          <element-item :isNum="true" :num="14"></element-item>
        </div>
        <div class="bottom">
          <element-item :element="elemetList[4]" @updateList="updateList"></element-item>
          <element-item :element="elemetList[5]" @updateList="updateList"></element-item>
        </div>
      </div>
      <!-- 氮、氧 -->
      <div class="first_tabel_item">
        <div class="top">
          <element-item :isNum="true" :num="15"></element-item>
          <element-item :isNum="true" :num="16"></element-item>
        </div>
        <div class="bottom">
          <element-item :element="elemetList[6]" @updateList="updateList"></element-item>
          <element-item :element="elemetList[7]" @updateList="updateList"></element-item>
        </div>
      </div>
      <!-- 氦、氟、氖 -->
      <div class="first_tabel_item">
        <div class="top" style="display: flex;justify-content: flex-end;">
          <element-item :isNum="true" :num="17"></element-item>
          <element-item :element="elemetList[1]" @updateList="updateList"></element-item>
        </div>
        <div class="bottom">
          <element-item :element="elemetList[8]" @updateList="updateList"></element-item>
          <element-item :element="elemetList[9]" @updateList="updateList"></element-item>
        </div>
      </div>
    </div>
    <!-- 第三行 -->
    <div class="other_table_item three">
      <element-item :element="elemetList[10]" @updateList="updateList"></element-item>
      <element-item :element="elemetList[11]" @updateList="updateList"></element-item>
      <element-item :isNum="true" :num="3 + item" v-for="item in 10" :key="item"></element-item>
      <element-item
        :element="elemetList[11 + item]"
        v-for="item in 6"
        :key="'b' + item"
        @updateList="updateList"
      ></element-item>
    </div>
    <!-- 第四行 -->
    <div class="other_table_item four">
      <element-item
        :element="elemetList[17 + item]"
        v-for="item in 18"
        :key="'c' + item"
        @updateList="updateList"
      ></element-item>
    </div>
    <!-- 第五行 -->
    <div class="other_table_item five">
      <element-item
        :element="elemetList[35 + item]"
        v-for="item in 18"
        :key="'d'+ item"
        @updateList="updateList"
      ></element-item>
    </div>
    <!-- 第六行 -->
    <div class="other_table_item six">
      <element-item :element="elemetList[54]" @updateList="updateList"></element-item>
      <element-item :element="elemetList[55]" @updateList="updateList"></element-item>
      <element-item :element="elemetList[118]" :isText="true" text="镧系"></element-item>
      <element-item
        :element="elemetList[70 + item]"
        v-for="item in 15"
        :key="'f'+ item"
        @updateList="updateList"
      ></element-item>
    </div>
    <!-- 第七行 -->
    <div class="other_table_item seven">
      <element-item :element="elemetList[86]" @updateList="updateList"></element-item>
      <element-item :element="elemetList[87]" @updateList="updateList"></element-item>
      <element-item :element="elemetList[119]" :isText="true" text="锕系"></element-item>
      <element-item
        :element="elemetList[102 + item]"
        v-for="item in 15"
        :key="'j'+ item"
        @updateList="updateList"
      ></element-item>
    </div>
    <!-- 第八行 -->
    <div class="other_table_item" style="display: flex;justify-content: center;margin-top: 30px;">
      <element-item :isText="true" text="镧系"></element-item>
      <element-item
        :element="elemetList[55 + item]"
        v-for="item in 15"
        :key="'h'+ item"
        @updateList="updateList"
      ></element-item>
    </div>
    <!-- 第九行 -->
    <div class="other_table_item" style="display: flex;justify-content: center;">
      <element-item :isText="true" text="锕系"></element-item>
      <element-item
        :element="elemetList[87 + item]"
        v-for="item in 15"
        :key="'i'+ item"
        @updateList="updateList"
      ></element-item>
    </div>
  </div>
</template>

<script>
import elementItem from "./element.vue";
export default {
  props: ['activeList'],
  components: {
    elementItem
  },
  data() {
    return {
      elemetList: [],
      activeElement: null,
      elements: [
        ["氢", "H", "non-metals", 1.008, [1]],
        ["氦", "He", "noble-gases", 4.0026, [2]],
        ["锂", "Li", "alkalai-metals", 6.94, [2, 1]],
        ["铍", "Be", "alkaline-earths", 9.0122, [2, 2]],
        ["硼", "B", "semi-metals", 10.81, [2, 3]],
        ["碳", "C", "non-metals", 12.011, [2, 4]],
        ["氮", "N", "non-metals", 14.007, [2, 5]],
        ["氧", "O", "non-metals", 15.999, [2, 6]],
        ["氟", "F", "halogens", 18.998, [2, 7]],
        ["氖", "Ne", "noble-gases", 20.18, [2, 8]],
        ["钠", "Na", "alkalai-metals", 22.99, [2, 8, 1]],
        ["镁", "Mg", "alkaline-earths", 24.305, [2, 8, 2]],
        ["铝", "Al", "other-metals", 26.982, [2, 8, 3]],
        ["硅", "Si", "semi-metals", 28.085, [2, 8, 4]],
        ["磷", "P", "non-metals", 30.974, [2, 8, 5]],
        ["硫", "S", "non-metals", 32.06, [2, 8, 6]],
        ["氯", "Cl", "halogens", 35.45, [2, 8, 7]],
        ["氩", "Ar", "noble-gases", 39.95, [2, 8, 8]],
        ["钾", "K", "alkalai-metals", 39.098, [2, 8, 8, 1]],
        ["钙", "Ca", "alkaline-earths", 40.078, [2, 8, 8, 2]],
        ["钪", "Sc", "transition-metals", 44.956, [2, 8, 9, 2]],
        ["钛", "Ti", "transition-metals", 47.867, [2, 8, 10, 2]],
        ["钒", "V", "transition-metals", 50.942, [2, 8, 11, 2]],
        ["铬", "Cr", "transition-metals", 51.996, [2, 8, 13, 1]],
        ["锰", "Mn", "transition-metals", 54.938, [2, 8, 13, 2]],
        ["铁", "Fe", "transition-metals", 55.845, [2, 8, 14, 2]],
        ["钴", "Co", "transition-metals", 58.933, [2, 8, 15, 2]],
        ["镍", "Ni", "transition-metals", 58.693, [2, 8, 16, 2]],
        ["铜", "Cu", "transition-metals", 63.546, [2, 8, 18, 1]],
        ["锌", "Zn", "transition-metals", 65.38, [2, 8, 18, 2]],
        ["镓", "Ga", "other-metals", 69.723, [2, 8, 18, 3]],
        ["锗", "Ge", "semi-metals", 72.63, [2, 8, 18, 4]],
        ["砷", "As", "semi-metals", 74.922, [2, 8, 18, 5]],
        ["硒", "Se", "non-metals", 78.971, [2, 8, 18, 6]],
        ["溴", "Br", "halogens", 79.904, [2, 8, 18, 7]],
        ["氪", "Kr", "noble-gases", 83.798, [2, 8, 18, 8]],
        ["铷", "Rb", "alkalai-metals", 85.468, [2, 8, 18, 8, 1]],
        ["锶", "Sr", "alkaline-earths", 87.62, [2, 8, 18, 8, 2]],
        ["钇", "Y", "transition-metals", 88.906, [2, 8, 18, 9, 2]],
        ["锆", "Zr", "transition-metals", 91.224, [2, 8, 18, 10, 2]],
        ["铌", "Nb", "transition-metals", 92.906, [2, 8, 18, 12, 1]],
        ["钼", "Mo", "transition-metals", 95.95, [2, 8, 18, 13, 1]],
        ["锝", "Tc", "transition-metals", 97, [2, 8, 18, 13, 2]],
        ["钌", "Ru", "transition-metals", 101.07, [2, 8, 18, 15, 1]],
        ["铑", "Rh", "transition-metals", 102.91, [2, 8, 18, 16, 1]],
        ["钯", "Pd", "transition-metals", 106.42, [2, 8, 18, 18]],
        ["银", "Ag", "transition-metals", 107.87, [2, 8, 18, 18, 1]],
        ["镉", "Cd", "transition-metals", 112.41, [2, 8, 18, 18, 2]],
        ["铟", "In", "other-metals", 114.82, [2, 8, 18, 18, 3]],
        ["锡", "Sn", "other-metals", 118.71, [2, 8, 18, 18, 4]],
        ["锑", "Sb", "semi-metals", 121.76, [2, 8, 18, 18, 5]],
        ["碲", "Te", "semi-metals", 127.6, [2, 8, 18, 18, 6]],
        ["碘", "I", "halogens", 126.9, [2, 8, 18, 18, 7]],
        ["氙", "Xe", "noble-gases", 131.29, [2, 8, 18, 18, 8]],
        ["铯", "Cs", "alkalai-metals", 132.91, [2, 8, 18, 18, 8, 1]],
        ["钡", "Ba", "alkaline-earths", 137.33, [2, 8, 18, 18, 8, 2]],
        ["镧", "La", "lanthanides", 138.91, [2, 8, 18, 18, 9, 2]],
        ["铈", "Ce", "lanthanides", 140.12, [2, 8, 18, 19, 9, 2]],
        ["镨", "Pr", "lanthanides", 140.91, [2, 8, 18, 21, 8, 2]],
        ["钕", "Nd", "lanthanides", 144.24, [2, 8, 18, 22, 8, 2]],
        ["钷", "Pm", "lanthanides", 145, [2, 8, 18, 23, 8, 2]],
        ["钐", "Sm", "lanthanides", 150.36, [2, 8, 18, 24, 8, 2]],
        ["铕", "Eu", "lanthanides", 151.96, [2, 8, 18, 25, 8, 2]],
        ["钆", "Gd", "lanthanides", 157.25, [2, 8, 18, 25, 9, 2]],
        ["铽", "Tb", "lanthanides", 158.93, [2, 8, 18, 27, 8, 2]],
        ["镝", "Dy", "lanthanides", 162.5, [2, 8, 18, 28, 8, 2]],
        ["钬", "Ho", "lanthanides", 164.93, [2, 8, 18, 29, 8, 2]],
        ["铒", "Er", "lanthanides", 167.26, [2, 8, 18, 30, 8, 2]],
        ["铥", "Tm", "lanthanides", 168.93, [2, 8, 18, 31, 8, 2]],
        ["镱", "Yb", "lanthanides", 173.05, [2, 8, 18, 32, 8, 2]],
        ["镥", "Lu", "lanthanides", 174.97, [2, 8, 18, 32, 9, 2]],
        ["铪", "Hf", "transition-metals", 178.49, [2, 8, 18, 32, 10, 2]],
        ["钽", "Ta", "transition-metals", 180.95, [2, 8, 18, 32, 11, 2]],
        ["钨", "W", "transition-metals", 183.84, [2, 8, 18, 32, 12, 2]],
        ["铼", "Re", "transition-metals", 186.21, [2, 8, 18, 32, 13, 2]],
        ["锇", "Os", "transition-metals", 190.23, [2, 8, 18, 32, 14, 2]],
        ["铱", "Ir", "transition-metals", 192.22, [2, 8, 18, 32, 15, 2]],
        ["铂", "Pt", "transition-metals", 195.08, [2, 8, 18, 32, 17, 1]],
        ["金", "Au", "transition-metals", 196.97, [2, 8, 18, 32, 18, 1]],
        ["汞", "Hg", "transition-metals", 200.59, [2, 8, 18, 32, 18, 2]],
        ["铊", "Tl", "other-metals", 204.38, [2, 8, 18, 32, 18, 3]],
        ["铅", "Pb", "other-metals", 207.2, [2, 8, 18, 32, 18, 4]],
        ["铋", "Bi", "other-metals", 208.98, [2, 8, 18, 32, 18, 5]],
        ["钋", "Po", "semi-metals", 209, [2, 8, 18, 32, 18, 6]],
        ["砹", "At", "halogens", 210, [2, 8, 18, 32, 18, 7]],
        ["氡", "Rn", "noble-gases", 222, [2, 8, 18, 32, 18, 8]],
        ["钫", "Fr", "alkalai-metals", 223, [2, 8, 18, 32, 18, 8, 1]],
        ["镭", "Ra", "alkaline-earths", 226, [2, 8, 18, 32, 18, 8, 2]],
        ["锕", "Ac", "actinides", 227, [2, 8, 18, 32, 18, 9, 2]],
        ["钍", "Th", "actinides", 232.04, [2, 8, 18, 32, 18, 10, 2]],
        ["镤", "Pa", "actinides", 231.04, [2, 8, 18, 32, 20, 9, 2]],
        ["铀", "U", "actinides", 238.03, [2, 8, 18, 32, 21, 9, 2]],
        ["镎", "Np", "actinides", 237, [2, 8, 18, 32, 22, 9, 2]],
        ["钚", "Pu", "actinides", 244, [2, 8, 18, 32, 24, 8, 2]],
        ["镅", "Am", "actinides", 243, [2, 8, 18, 32, 25, 8, 2]],
        ["锔", "Cm", "actinides", 247, [2, 8, 18, 32, 25, 9, 2]],
        ["锫", "Bk", "actinides", 247, [2, 8, 18, 32, 27, 8, 2]],
        ["锎", "Cf", "actinides", 251, [2, 8, 18, 32, 28, 8, 2]],
        ["锿", "Es", "actinides", 252, [2, 8, 18, 32, 29, 8, 2]],
        ["镄", "Fm", "actinides", 257, [2, 8, 18, 32, 30, 8, 2]],
        ["钔", "Md", "actinides", 258, [2, 8, 18, 32, 31, 8, 2]],
        ["锘", "No", "actinides", 259, [2, 8, 18, 32, 32, 8, 2]],
        ["铹", "Lr", "actinides", 266, [2, 8, 18, 32, 32, 8, 3]],
        ["𬬻", "Rf", "transition-metals", 267, [2, 8, 18, 32, 32, 10, 2]],
        ["𬭊", "Db", "transition-metals", 268, [2, 8, 18, 32, 32, 11, 2]],
        ["𬭳", "Sg", "transition-metals", 269, [2, 8, 18, 32, 32, 12, 2]],
        ["𬭛", "Bh", "transition-metals", 270, [2, 8, 18, 32, 32, 13, 2]],
        ["𬭶", "Hs", "transition-metals", 277, [2, 8, 18, 32, 32, 14, 2]],
        ["鿏", "Mt", "transition-metals", 278, [2, 8, 18, 32, 32, 15, 2]],
        ["𫟼", "Ds", "transition-metals", 281, [2, 8, 18, 32, 32, 16, 2]],
        ["𬬭", "Rg", "transition-metals", 282, [2, 8, 18, 32, 32, 17, 2]],
        ["鿔", "Cn", "transition-metals", 285, [2, 8, 18, 32, 32, 18, 2]],
        ["鿭", "Nh", "uncategorized", 286, [2, 8, 18, 32, 32, 18, 3]],
        ["𫓧", "Fl", "uncategorized", 289, [2, 8, 18, 32, 32, 18, 4]],
        ["镆", "Mc", "uncategorized", 290, [2, 8, 18, 32, 32, 18, 5]],
        ["𫟷", "Lv", "uncategorized", 293, [2, 8, 18, 32, 32, 18, 6]],
        ["鿬", "Ts", "uncategorized", 294, [2, 8, 18, 32, 32, 18, 7]],
        ["鿫", "Og", "uncategorized", 294, [2, 8, 18, 32, 32, 18, 8]],
        ["镧系", "", "lanthanides", 0, []],
        ["锕系", "", "actinides", 0, []]
      ]
    };
  },
  watch: {
	  'activeList': {
		  handler(val) {
		  }
	  }
  },
  created() {
    
  },
  methods: {
    init (item) {
      this.$nextTick(()=> {
        let noList = item.noCheck && item.noCheck != '' ? item.noCheck.split(',') : []
        let needElement = item.needElement && item.needElement != '' ? item.needElement.split(',') : []
        let valueList = item.fieIdValue && item.fieIdValue != '' ? item.fieIdValue.split(',') : []
        let valuesList = needElement.concat(valueList)
        this.elemetList = this.elements.map((element, index) => {
          return {
            index: index + 1,
            name: element[0],
            code: element[1],
            class: element[2],
            quality: element[3],
            electron: element[4],
            disable: noList.includes(element[1]),
            isChoose: valuesList.includes(element[1]),
            isNeed: needElement.includes(element[1])
          };
        });
        this.updateList(this.elemetList)
        // noCheck
      })
    },
    updateList(data) {
      this.activeElement = data;
      const foundElement = this.elemetList.find(
        item => item.index === data.index
      );
      if (foundElement) {
        foundElement.isChoose = data.isChoose;
	    }
	    this.$emit('updateActive',this.elemetList)
    }
  }
};
</script>

<style lang="scss">
.line {
  height: 22px;
  display: flex;
  margin: 0 auto;
  padding-right: 20px;

  .line_item {
    height: 22px;
    font-size: 20px;
    color: #444444;
    text-align: center;
    vertical-align: bottom;
  }
}

.first_tabel {
  display: flex;
  flex-flow: row nowrap;
  margin-top: 4px;
  .first_tabel_right {
    display: flex;
  }
  .first_tabel_blank {
    width: 110px;
  }
  .first_tabel_electron {
    width: 255px;
  }

  .first_tabel_item {
    .top {
      height: 57px;
      display: flex;
    }

    .bottom {
      margin-top: 4px;
      display: flex;
    }
  }
}

.other_table_item {
  margin-top: 4px;
  height: 57px;
  display: flex;
  position: relative;
}
</style>